import { render, staticRenderFns } from "./sage.vue?vue&type=template&id=53caf64c&scoped=true"
import script from "./sage.vue?vue&type=script&lang=js"
export * from "./sage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53caf64c",
  null
  
)

export default component.exports